import React, { useState } from "react";
import Container from "@mui/material/Container";
import {
	AppBar,
	Avatar,
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	CssBaseline,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Stack,
	TextField,
	ThemeProvider,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { relative } from "path";
import logo from "../assets/logo.png";
import image1 from "../assets/image_1.png";
import image2 from "../assets/image_2.png";
import { useAuth } from "../providers/AuthenticationProvider";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const GoAffiliate = () => {
	const { traderProfile, profile } = useAuth();
	const navigate = useNavigate();
	const { t } = useTranslation();
	
	return (
		<Container>
			<Box
				sx={{
                    marginTop: "8vh",
					padding: "4vh"
				}}
			>
				<Stack spacing={2}>
					<Box
						sx={{
							backgroundSize: "cover",
							borderRadius: "8px",
							backgroundPosition: "center",
							width: "100%",
							backgroundColor: "#147A7A",
							padding: "4vh 20px",
						}}
					>
						<Typography
							variant="h4"
							sx={{
								fontFamily: "Work Sans !important",
								fontWeight: "bold",
								fontSize:
									window.innerWidth < 600 ? "24px" : "28px",
							}}
						>
							{
							t("goaffiliate.t1")
							}

						</Typography>
						<Typography
							sx={{
								fontFamily: "Work Sans !important",
							}}
						>
							{
							t("goaffiliate.t2")
							}
							
						</Typography>
					</Box>

					<Box>
						<h3>
						{t("goaffiliate.t3")}
							
                        </h3>
						<p>
						{t("goaffiliate.t4")}
                        </p>
                        <br></br>
                        <h3>
						{t("goaffiliate.t5")}
                        </h3>
						<p>
						{t("goaffiliate.t6")}
						</p>
						<br></br>
                        <h3>
							{t("goaffiliate.t7")}
							
                        </h3>
                            <p>
								{t("goaffiliate.t8")}
								
                                <ul>
                                    <li>
									{t("goaffiliate.t9")}
                                           
                                    </li>
                                    <li>
									{t("goaffiliate.t10")}
                                    
                                    </li>
                                </ul>
                            </p>
                            <br></br>
					</Box>

					<Box
						sx={{
							backgroundSize: "cover",
							borderRadius: "8px",
							backgroundPosition: "center",
							width: "100%",
							backgroundColor: "#232839",
							padding: "4vh 20px",
						}}
					>
						<Grid container>
							<Grid xs={12} sm={8}>
								<Typography
									variant="h4"
									sx={{
										fontFamily: "Work Sans !important",
										fontWeight: "bold",
										fontSize:
											window.innerWidth < 600
												? "24px"
												: "28px",
									}}
								>
									{t("goaffiliate.t11")} 
								</Typography>
								<Typography
									sx={{
										fontFamily: "Work Sans !important",
									}}
								>
									<b>{t("goaffiliate.t12")}:</b> {t("goaffiliate.t13")} <a
									href="mailto:info@xseetrading.com"
									style={{ color: "#147A7A" }}
								>
									<b>info@xseetrading.com</b>
								</a> {t("goaffiliate.t14")}.
								</Typography>
							</Grid>

							<Grid xs={0} sm={4}></Grid>
						</Grid>
					</Box>

				</Stack>
			</Box>
			<Box
				sx={{
					padding: window.innerWidth > 600 ? "8vh 0" : "2vh 1vh",
				}}
			>
				<Container>
					<Grid container spacing={2}>
						<Grid md={2} xs={0}></Grid>
						<Grid md={4} xs={12}>
							<a
								className="footer_url"
								style={{ color: "#fff" }}
								onClick={() => navigate("terms-condition")}
								target="_blank"
							>
								Terms of use
							</a>
						</Grid>
						<Grid md={4} xs={12}>
							<a
								className="footer_url"
								style={{ color: "#fff" }}
								onClick={() => navigate("privacy-policy")}
								target="_blank"
							>
								Privacy Policy
							</a>
						</Grid>
					</Grid>
				</Container>
			</Box>
		</Container>
	);
};
